import {withSystem, EnvTypes} from '@packages/systems/wfdl';
import {
  TPredicate,
  toBooleanTag,
} from '@packages/systems/plugins-utils/Boolean';
import {tyfun, forall} from '@packages/utilities/wfdl-helpers';
import {
  TOperand,
  toOperandExpr,
} from '@packages/systems/plugins/ConditionsOperand';
import {
  TGenericStyleVariant,
  TGenericStyleVariantAnyOfList,
} from '../datatypes/StyleVariantAnyOfList';

export const styleVariantIsAny: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: withSystem(
      {label: 'is any'},
      forall(
        ['a', 'b', 'c'],
        tyfun([TGenericStyleVariantAnyOfList], TPredicate(TGenericStyleVariant))
      )
    ),
    exported: 'visible',
  },
  value: (predArgList: string[]) => (fieldVal: string) => {
    return toBooleanTag(predArgList.includes(fieldVal));
  },
};

export const styleVariantIsNotAny: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: withSystem(
      {label: 'is not any'},
      forall(
        ['a', 'b', 'c'],
        tyfun([TGenericStyleVariantAnyOfList], TPredicate(TGenericStyleVariant))
      )
    ),
    exported: 'visible',
  },
  value: (predArgList: string[]) => (fieldVal: string) => {
    return toBooleanTag(!predArgList.includes(fieldVal));
  },
};

export const styleVariantCondition: EnvTypes.SafeTypedValue = {
  envType: {
    dataType: forall(
      ['a', 'b', 'c'],
      tyfun([TGenericStyleVariant], TOperand(TGenericStyleVariant))
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  expression: toOperandExpr,
};
